module.exports = __webpack_public_path__ + "static/media/web_driver.50699614.gif";